import { authenticatedFetch } from './auth';

export type AspspStatus = 'active' | 'draft' | 'apocryphal';

export interface AspspInfo {
  id: string;
  name: string;
  country: string;
  bic?: string;
  legal_name?: string;
  supports_ais: boolean;
  supports_pis: boolean;
  has_sandbox: boolean;
  status: AspspStatus;
}

export interface ConnectResponse {
  authorization_url: string;
  expires_in: number;
}

/**
 * Fetch the list of available ASPSPs (banks).
 */
export async function fetchAspsps(): Promise<AspspInfo[]> {
  const res = await authenticatedFetch('/v1/aspsps');
  if (!res.ok) {
    throw new Error('Failed to fetch banks');
  }
  return res.json();
}

/**
 * Initiate OAuth connection to a bank.
 * Sends requested scopes (optional) and returns the authorization URL.
 */
export async function connectAspsp(
  aspspId: string,
  requestedScope: string[] = [],
): Promise<ConnectResponse> {
  const res = await authenticatedFetch(`/v1/aspsps/${encodeURIComponent(aspspId)}/connect`, {
    method: 'POST',
    body: JSON.stringify({ requested_scope: requestedScope }),
  });
  if (!res.ok) {
    const body = await res.json().catch(() => ({ message: 'Connection failed' }));
    throw new Error(body.message || 'Failed to initiate bank connection');
  }
  return res.json();
}
